var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8205 0.5H2.29437C1.33672 0.5 0.5 1.18906 0.5 2.13547V19.7005C0.5 20.652 1.33672 21.5 2.29437 21.5H19.8153C20.7781 21.5 21.5 20.6464 21.5 19.7005V2.13547C21.5056 1.18906 20.7781 0.5 19.8205 0.5ZM7.00953 18.0045H4.00109V8.65063H7.00953V18.0045ZM5.60937 7.22844H5.58781C4.625 7.22844 4.00156 6.51172 4.00156 5.61453C4.00156 4.70094 4.64141 4.00109 5.62578 4.00109C6.61016 4.00109 7.2125 4.69578 7.23406 5.61453C7.23359 6.51172 6.61016 7.22844 5.60937 7.22844ZM18.0045 18.0045H14.9961V12.89C14.9961 11.6647 14.5583 10.8275 13.4698 10.8275C12.6383 10.8275 12.1461 11.39 11.9272 11.938C11.8452 12.1348 11.8231 12.403 11.8231 12.6767V18.0045H8.81469V8.65063H11.8231V9.95234C12.2609 9.32891 12.9448 8.43172 14.5362 8.43172C16.5111 8.43172 18.005 9.73344 18.005 12.5398L18.0045 18.0045Z",
    fill: "#1D1D1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).6bcd42faf5cf6d2697b5397bd1bb6615.svg";
export { ForwardRef as ReactComponent };